import React from 'react';
import { Card, CardHeader } from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import LightBulbIcon from 'material-ui/svg-icons/action/lightbulb-outline';

export default ({ style, translate }) => (
    <Card style={style}>
        <CardHeader
            title="Welcome to Ocha Admin"
            avatar={<Avatar backgroundColor="#FFEB3B" icon={<LightBulbIcon />} />}
        />
    </Card>
);



// WEBPACK FOOTER //
// ./src/routes/dashboard/Welcome.js